const variants = {
  warning: {
    background: '#00AF8619',
    borderColor: 'warning',
  },
  danger: {
    background: '#00AF8619',
    borderColor: 'failure',
  },
  success: {
    background: 'rgba(49, 208, 170, 0.1)',
    borderColor: 'success',
  },
}

export default variants
